'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _highlite = require('../../../services/highlite');

var _highlite2 = _interopRequireDefault(_highlite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    (0, _highlite2.default)(this.$el);
  },

  props: ['docs'],
  template: '\n    <div>\n      <template v-if="docs">\n          <div v-for="(doc, index) in docs" :key="index">\n          <div v-html="doc" class="markdown-body"></div>\n          </div>\n      </template>\n    </div>\n  '
};